import { Vue, Component, Prop, Watch } from '@/utils';

@Component({
  name: 'number-spinner',
})
export class NumberSpinner extends Vue {
  @Prop() value: number;
  @Prop({ default: 0 }) min: number;
  @Prop() max: number;
  @Prop({ default: 1 }) step: number;
  @Prop({ default: true }) integerOnly: boolean;

  numericValue = 0;

  mounted() {
    this.numericValue = this.value;
  }

  @Watch('value')
  onValueChanged() {
    this.numericValue = this.value;
  }

  @Watch('numericValue')
  onNumbericVaue(val, oldVal) {
    if (val <= this.min) { this.numericValue = this.min; }
    if (val >= this.max) { this.numericValue = this.max; }
    if (val <= this.max && val >= this.min) {
      this.$emit('input', val, oldVal);
    }
  }

  increaseNumber() {
    this.numericValue += this.step;
  }

  decreaseNumber() {
    this.numericValue -= this.step;
  }

  isInteger(evt) {
    evt = (evt) ? evt : window.event;
    let key = evt.keyCode || evt.which;
    key = String.fromCharCode(key);
    const regex = /[0-9]/;
    if (!regex.test(key)) {
      evt.returnValue = false;
      if (evt.preventDefault) evt.preventDefault();
    }
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
      evt.preventDefault();
    }
    else {
      return true;
    }
  }

  validateInput(evt) {
    if (this.integerOnly === true) {
      this.isInteger(evt);
    }
    else {
      this.isNumber(evt);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/number-spinner.ts